export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.6754035d5dc56ff8f16c.worker.js");
}
